import api from '../api';

/**
 * Serviço para buscar todas as molduras de uma rede específica
 */
const fetchMolduras = async (idRede) => {
  if (!idRede) {
    throw new Error('ID da rede é obrigatório');
  }

  try {
    // Endpoint para listar imagens, filtrando por tipo "moldura"
    const apiUrl = process.env.REACT_APP_API_BASE_70;
    
    const response = await api.get(`${apiUrl}?id_rede=${idRede}&tipo=moldura`);
    
    if (response.data && response.data.imagens) {
      // Organizando os dados para facilitar o uso
      return {
        success: true,
        total: response.data.total,
        molduras: response.data.imagens.map(moldura => ({
          id: moldura.file_id,
          nome: moldura.nome_arquivo,
          descricao: moldura.descricao || '',
          nomeMoldura: moldura.nome || '',
          url: moldura.url,
          thumbnailUrl: moldura.thumbnail_url || moldura.url,
          dataUpload: new Date(moldura.data_upload)
        }))
      };
    }
    
    return {
      success: false,
      message: 'Formato de resposta inválido'
    };
  } catch (error) {
    console.error('Erro ao buscar molduras:', error);
    
    return {
      success: false,
      message: error.response?.data?.error || 'Erro ao buscar molduras',
      error
    };
  }
};

export default fetchMolduras;